import { INetworkResult } from '@/coreDomainsModule/networkResult';
import { IBusinessListForecastForReceiptResult } from '../domains/entities/businessListForecastForReceiptResult';
import { BusinessListForecastForReceiptAdapter } from '../adapter/businessListForecastForReceiptAdapter';
import { IYearMonth } from '@/coreDomainsModule/date';
import { initPagingOptions, IPagingOptions } from '@/coreDomainsModule/paging';
import { CustomerForecastRepository } from '@/coreInfrastructureModule/Repositories/CustomerForecastRepository';
import { FilterContentItem } from '@/corePagesModule/filterModal/filterModal';
import { FilterService } from '@/coreDomainsModule/services/filterService';

/**
 * -
 */
export class GetAllCustomerForecastUseCase {
  private defaultPagingOptions: IPagingOptions = initPagingOptions(30); // TODO: ページごとに変わる可能性あるので要確認

  /**
   * DBから受領用内示に紐づく取引のうち、指定した受領月に該当する取引を取得する
   * @param repository - リポジトリ
   * @param receivedForecastYearMonthInfo - 表示する内示の受領月
   * @param pagingOptions - ページングオプション
   * @param sortKey - ソートキー
   * @param sortTargetYearMonth - ソート対象の年月(内示値用)
   * @param isAsc - 昇順かどうか
   * @param filterItems - フィルター項目
   */
  public async Execute(
    repository: CustomerForecastRepository,
    receivedForecastYearMonthInfo: IYearMonth,
    pagingOptions?: IPagingOptions,
    sortKey?: string,
    sortTargetYearMonth?: IYearMonth,
    isAsc?: boolean,
    filterItems?: FilterContentItem[]
  ): Promise<INetworkResult<IBusinessListForecastForReceiptResult, Error>> {
    try {
      const usePagingOptions = pagingOptions || this.defaultPagingOptions;
      const sortType = isAsc ? 'ASC' : 'DESC';
      const useFilterItem = filterItems ? FilterService.convertCustomerForecastFilterItems(filterItems) : undefined;
      const result = await repository.getAll(
        sortType,
        usePagingOptions.pageSize,
        usePagingOptions.offset,
        receivedForecastYearMonthInfo.year,
        receivedForecastYearMonthInfo.month,
        useFilterItem,
        false,
        sortKey,
        sortTargetYearMonth?.year,
        sortTargetYearMonth?.month
      );

      switch (result.status.type) {
        case 'success':
          break;
        case 'error':
          throw result.status.error;
        default:
          throw new Error('Invalid status');
      }

      const businessListForecastForReceiptResult = BusinessListForecastForReceiptAdapter.adapt(result.status.data, usePagingOptions);
      return {
        status: {
          type: 'success',
          data: businessListForecastForReceiptResult,
        },
      };
    } catch (error) {
      return {
        status: {
          type: 'error',
          error: Error('取得に失敗しました'),
        },
      };
    }
  }
}
